module.exports = __webpack_public_path__ + "img/c5.c4ba2631.png";